<template>
	<Modal class="video-player-modal">
		<div class="video-player-container">
			<div class="video-content">
				<div class="video-player-header">
					<h2 class="video-player-title">
						{{ title }}
					</h2>
					<div class="video-header-buttons">
						<button
							v-if="urlMatApoio"
							class="btn-material-apoio"
							@click="openLink(urlMatApoio)"
						>
							<img
								src="@/assets/download-icon.png"
								alt="download"
							/>
							{{ $t('supportMaterial') }}
						</button>
						<button
							class="btn-close"
							@click="$emit('close')"
						>
							<img
								src="@/assets/X-btn.png"
								alt="close"
							/>
						</button>
					</div>
				</div>
				<iframe
					:src="getYoutubeEmbedUrl(videoSrc)"
					class="video-player"
					frameborder="0"
					allowfullscreen
				/>
			</div>
		</div>
	</Modal>
</template>
<script>
export default {
	name: 'VideoPlayer',
	props: {
		videoSrc: {
			type: String,
			required: true,
		},
		title: {
			type: String,
			default: '',
			required: true,
		},
		urlMatApoio: {
			type: String,
			default: '',
			required: false,
		},
	},
	data() {
		return {}
	},
	mounted() {
		this.$refs.videoPlayer.load()
	},
	methods: {
		getYoutubeEmbedUrl(url) {
			// Se for só o ID, retorna direto
			if (/^[\w-]{11}$/.test(url)) {
				return `https://www.youtube.com/embed/${url}`
			}
			// Se for uma URL completa, extrai o ID
			const match = url.match(/(?:v=|\/embed\/|\.be\/)([\w-]{11})/)
			return match ? `https://www.youtube.com/embed/${match[1]}` : ''
		},
		openLink(url) {
			window.open(url, '_blank')
		},
	},
}
</script>
<style scoped>
.video-player-modal {
	background-color: rgba(0, 0, 0, 0.4);
	position: fixed;
	height: calc(100vh - 40px);
	width: 100%;
	left: 0;
	top: 2.5rem;
	display: flex;
	justify-content: center;
	z-index: 15;
}
.video-player-container {
	position: fixed;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	z-index: 15;
	background: var(--Neutral-Colors-Neutral-White, #fefefe);
	border-radius: 8px;
	box-shadow: 0 8px 32px rgba(0, 0, 0, 0.25);
	padding: 40px;
	display: flex;
	flex-direction: column;
	align-items: stretch;
	width: 90vw;
	height: 85vh;
	gap: 16px;
}

.video-player {
	width: 100%;
	height: 70vh;
	border-radius: 8px;
	background: #000;
	object-fit: contain;
}

.video-header-buttons {
	display: flex;
	align-items: flex-end;
	justify-content: flex-end;
	flex-direction: row;
	gap: var(--spacing-default, 16px);
}

.video-player-title {
	color: var(--grays-gray-dark, #464947);
	/* text-l-bold */
	font-family: 'Open Sans';
	font-size: 18px;
	font-style: normal;
	font-weight: 700;
	line-height: 20px; /* 111.111% */
	letter-spacing: -0.5px;
	display: flex;
	justify-content: flex-start;
}
.video-player-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	align-self: stretch;
}

.btn-material-apoio {
	display: flex;
	padding: var(--spacing-xs, 4px) var(--spacing-s, 8px);
	justify-content: center;
	align-items: flex-start;
	gap: var(--spacing-s, 8px);
	border-radius: var(--border-xs, 4px);
	border: 1px solid var(--secondary-secondary, #01395e);
	background: var(--neutrals-neutral-white, #fefefe);
}

.btn-close {
	display: flex;
	padding: var(--spacing-xs, 4px);
	justify-content: center;
	align-items: flex-start;
	gap: var(--spacing-s, 8px);
	border-radius: var(--border-xs, 4px);
	border: 1px solid var(--neutrals-neutral-black, #272728);
	background: var(--primary-primary, #95bb49);
}
.video-content {
	display: flex;
	flex-direction: column;
	gap: 16px !important;
}
</style>
